import { PORTAL_HOMEPAGE_URL } from "constants/host";

const renderDocumentLookupLink = (documentRegisterId: string) => {
  if (!documentRegisterId) return "";

  const encodedText = encodeURIComponent(documentRegisterId);
  return `${PORTAL_HOMEPAGE_URL}/id=${encodedText}`;
};

export { renderDocumentLookupLink };
